<template>
  <div class="slider-mobile">
    <info-block class="slider-mobile__info" :slide="slide"></info-block>
    <background-image class="slider-mobile__background" :image="slide.image"></background-image>
  </div>
</template>

<script>
  import Vue from 'vue'
  import BackgroundImage from "./BackgroundImage";
  import InfoBlock from "./InfoBlock";
  import {mapState} from 'vuex'

  export default {
    name: "SliderMobile",
    components: {
      BackgroundImage,
      InfoBlock
    },
    computed: {
      ...mapState(['slidesArray','slideNumber']),
    },
    props: {
      index: Number,
      slide: Object
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../styles/tools'
  .slider-mobile
    position relative
    z-index 5
    box-sizing border-box
    display flex
    flex-direction column-reverse
    justify-content center
    width 100%
    height auto
    background-color $backgroundBlue
    &__background
      height 75vh
      width 100%
    &__info
      padding 70px 40px 40px 120px
      @media (max-width 600px)
        padding 40px 20px

</style>